(function(){
  var root = document.querySelector('[data-vl]'); if (!root || root._vl) return; root._vl = 1;
  var START = Date.parse(root.getAttribute('data-vl-start'));
  var ENDE = root.getAttribute('data-vl-ende') ? Date.parse(root.getAttribute('data-vl-ende')) : NaN;
  var q = new URLSearchParams(location.search);
  var vorschau = q.get('vl_stand');
  if (['vor','live','ende'].indexOf(vorschau) < 0) vorschau = null;
  function stand(t){ if (t < START) return 'vor'; if (!isNaN(ENDE) && t >= ENDE) return 'ende'; return 'live'; }
  var fs = root.querySelector('[data-vl-fs]');
  var cells = {}; ['d','h','m','s'].forEach(function(k){ cells[k] = root.querySelector('[data-cd="'+k+'"]'); });
  var hint = root.querySelector('[data-vl-ohne-ende]');
  function zwei(n){ return (n < 10 ? '0' : '') + n; }
  function tick(){
    var t = Date.now(), echt = stand(t), zeig = vorschau || echt;
    root.setAttribute('data-vl-stand', zeig);
    if (fs) fs.disabled = zeig !== 'live';
    var ziel = zeig === 'vor' ? START : ENDE;
    if (vorschau === 'vor' && echt !== 'vor') ziel = NaN;
    if (hint) hint.hidden = !(zeig === 'live' && isNaN(ENDE));
    if (isNaN(ziel) || !cells.d) { ['d','h','m','s'].forEach(function(k){ if (cells[k]) cells[k].textContent = '–'; }); return; }
    var r = Math.max(0, Math.floor((ziel - t) / 1000));
    cells.d.textContent = Math.floor(r / 86400);
    cells.h.textContent = zwei(Math.floor(r % 86400 / 3600));
    cells.m.textContent = zwei(Math.floor(r % 3600 / 60));
    cells.s.textContent = zwei(r % 60);
  }
  tick(); setInterval(tick, 1000);

  /* Teilnahmebedingungen öffnen, wenn darauf verlinkt wird */
  function oeffneTb(){ if (location.hash === '#teilnahmebedingungen') { var d = document.getElementById('teilnahmebedingungen'); if (d) d.open = true; } }
  oeffneTb(); window.addEventListener('hashchange', oeffneTb);
  root.querySelectorAll('[data-vl-tb]').forEach(function(a){ a.addEventListener('click', function(){ var d = document.getElementById('teilnahmebedingungen'); if (d) d.open = true; }); });

  /* Empfehlungs-Code: nur aus dem Link, nur für diese Sitzung gemerkt */
  function lies(k, store){ try { return window[store].getItem(k); } catch(e) { return null; } }
  function schreib(k, v, store){ try { window[store].setItem(k, v); } catch(e) {} }
  var ref = (q.get('ref') || '').toLowerCase();
  if (/^[a-z0-9]{6}$/.test(ref)) schreib('sbVlRef', ref, 'sessionStorage');

  function neuerCode(){
    var abc = 'abcdefghjkmnpqrstuvwxyz23456789', out = '', a = new Uint32Array(6);
    (window.crypto || window.msCrypto).getRandomValues(a);
    for (var i = 0; i < 6; i++) out += abc.charAt(a[i] % abc.length);
    return out;
  }

  /* Formular: Prüfung direkt am Feld, Code als Schlagwort */
  var form = document.getElementById('sb-vl-form');
  var tags = root.querySelector('[data-vl-tags]');
  if (form && tags) {
    var felder = [
      { el: form.querySelector('#vl-vorname'), err: form.querySelector('#vl-err-vorname'), ok: function(el){ return el.value.trim().length > 0; } },
      { el: form.querySelector('#vl-email'), err: form.querySelector('#vl-err-email'), ok: function(el){ return /^[^ @]+@[^ @]+[.][^ @.]{2,}$/.test(el.value.trim()); } },
      { el: form.querySelector('#vl-ok'), err: form.querySelector('#vl-err-ok'), ok: function(el){ return el.checked; } }
    ];
    function pruef(f){ var gut = f.ok(f.el); f.err.hidden = gut; if (gut) f.el.removeAttribute('aria-invalid'); else f.el.setAttribute('aria-invalid','true'); return gut; }
    felder.forEach(function(f){ f.el.addEventListener('blur', function(){ if (f.el.value || f.el.type === 'checkbox') pruef(f); }); f.el.addEventListener('change', function(){ if (f.el.getAttribute('aria-invalid')) pruef(f); }); });
    form.addEventListener('submit', function(e){
      if ((fs && fs.disabled) || stand(Date.now()) !== 'live') { e.preventDefault(); return; }
      var erster = null;
      felder.forEach(function(f){ if (!pruef(f) && !erster) erster = f.el; });
      if (erster) { e.preventDefault(); erster.focus(); return; }
      var code = neuerCode(), t = ['newsletter', 'verlosung-2026', 'vl-code-' + code];
      var r = lies('sbVlRef', 'sessionStorage');
      if (r && r !== code) t.push('vl-ref-' + r);
      tags.value = t.join(', ');
      schreib('sbVlCode', code, 'localStorage');
    });
  }

  /* Nach dem Absenden: persönlicher Link */
  var ok = root.querySelector('[data-vl-ok]');
  if (ok) {
    var code = lies('sbVlCode', 'localStorage');
    var box = ok.querySelector('[data-vl-linkbox]'), inp = ok.querySelector('[data-vl-link]');
    if (code && /^[a-z0-9]{6}$/.test(code)) {
      var url = location.origin + '/pages/verlosung?ref=' + code;
      inp.value = url; box.hidden = false;
      var meld = ok.querySelector('[data-vl-copied]');
      ok.querySelector('[data-vl-copy]').addEventListener('click', function(){
        function fertig(){ meld.textContent = 'Link kopiert.'; }
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(fertig, function(){ inp.select(); try { document.execCommand('copy'); fertig(); } catch(e) {} });
        else { inp.select(); try { document.execCommand('copy'); fertig(); } catch(e) {} }
      });
      var share = ok.querySelector('[data-vl-share]');
      if (navigator.share && window.matchMedia('(pointer: coarse)').matches) {
        share.hidden = false;
        share.addEventListener('click', function(){ navigator.share({ title: 'Ein Stück Heimat gewinnen', text: 'Weihnachtsverlosung von Salibo & Design', url: url }).catch(function(){}); });
      }
    } else {
      ok.querySelector('[data-vl-nolink]').hidden = false;
    }
    ok.focus();
  }
})();
